import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

import useDateOptions from "@/features/FilterTable/useDateOptions";

const filterA7FIACompositionsSchema = z.object({
  date_equals: z.string().optional(),
  fund_name_contains: z.string().optional(),
  instrument_to_id_equals: z.string().optional(),
  file_id_equals: z.string().optional(),
  vehicle_contains: z.string().optional(),
});

export type FilterA7FIACompositionsSchema = z.infer<
  typeof filterA7FIACompositionsSchema
>;

const initialFields: Field[] = [
  {
    name: "date_equals",
    label: `Date`,
    type: "autocomplete",
    options: [],
  },
  {
    name: "fund_name_contains",
    label: `Fonds`,
    type: "input",
  },
  {
    name: "instrument_to_id_equals",
    label: `Instrument financier`,
    type: "input",
    input_type: "number",
    allowNegative: false,
  },
  {
    name: "file_id_equals",
    label: `Fichier`,
    type: "input",
  },
  {
    name: "vehicle_contains",
    label: `Véhicle`,
    type: "input",
  },
];

export function FilterA7FIACompositions({
  table_name,
  client,
}: {
  client: string;
  table_name: string;
}) {
  const { fields } = useDateOptions(client, table_name, initialFields);

  return (
    <FilterTable
      client={client}
      schema={filterA7FIACompositionsSchema}
      tableName="a7_fia_compositions"
      fields={fields}
      customBuildPath={() => `a7-fia/${table_name}`}
      excludeFieldsFromConvertDate={["date_equals"]}
    />
  );
}
